import React, { useRef } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import WarehouseInventory from "./WarehouseInventory";
import Warehouseaccuracy from "./Warehouseaccuracy";
import Warehousetable from "./Warehousetable";
import Warehousesaleratio from "./Warehousesaleratio";
import WarehouseTurnover from "./WarehouseTurnover";
import Warehousestocklist from "./Warehousestocklist";
export default function Warehousedashboardcards() {
  const inventoryaccuracyRef = useRef(null);
  const inventorysaleRatioRef = useRef(null);
  const inventoryturnoverRef = useRef(null);
  const StockRef = useRef(null);
  const PickingaccuracyRef = useRef(null);

 

  const handleScroll = (ref) => {
    console.log("scrool down");
    window.scrollTo({
      top: ref.offsetTop - 100,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="flex flex-col container mt-2 mb-5 ">
      <div class="flex flex-wrap justify-center mt-8">
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(inventoryaccuracyRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8684 17.263L17.222 16.9095L17.5755 17.263L17.222 17.6166L16.8684 17.263ZM13.0246 12.7121L17.222 16.9095L16.5149 17.6166L12.3175 13.4192L13.0246 12.7121ZM17.222 17.6166L13.0246 21.814L12.3175 21.1069L16.5149 16.9095L17.222 17.6166Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.7204 8.86841L17.9177 8.86841"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.8684 17.2631H8.47368C6.15553 17.2631 4.27631 15.3839 4.27631 13.0658V13.0658C4.27631 10.7476 6.15553 8.86841 8.47368 8.86841H9.52302"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">34%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Inventory Accuracy
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(StockRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="6"
                    height="6"
                    rx="1"
                    transform="matrix(1 0 0 -1 14 10)"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 14H14C14.9428 14 15.4142 14 15.7071 14.2929C16 14.5858 16 15.0572 16 16V18C16 18.9428 16 19.4142 15.7071 19.7071C15.4142 20 14.9428 20 14 20H10V14Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 10C10 9.05719 10 8.58579 9.70711 8.29289C9.41421 8 8.94281 8 8 8H6C5.05719 8 4.58579 8 4.29289 8.29289C4 8.58579 4 9.05719 4 10V14H10V10Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V14H10V20Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">526</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Stock
          </h1>
       
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(inventorysaleRatioRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">18</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Inventory to Sales Ratio
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl "
          onClick={() => {
            handleScroll(inventoryturnoverRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="6"
                    height="6"
                    rx="1"
                    transform="matrix(1 0 0 -1 14 10)"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 14H14C14.9428 14 15.4142 14 15.7071 14.2929C16 14.5858 16 15.0572 16 16V18C16 18.9428 16 19.4142 15.7071 19.7071C15.4142 20 14.9428 20 14 20H10V14Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 10C10 9.05719 10 8.58579 9.70711 8.29289C9.41421 8 8.94281 8 8 8H6C5.05719 8 4.58579 8 4.29289 8.29289C4 8.58579 4 9.05719 4 10V14H10V10Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V14H10V20Z"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">34</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Inventory Turnover
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">05.25%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-2/4  flex-wrap justify-center mt-8 mb-8">
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4 pt-8">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4 pt-8">$200</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 pt-4 font-bold ">
            Shrinkage
          </h1>
          <p className="text-lime-400 text-center mb-1 ">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 pt-4 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>

        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6" onClick={() => {
            handleScroll(PickingaccuracyRef.current);
          }}>
        <div className=" px-9 mt-7 m-auto ">
        <CircularProgressbar
          value={65}
          text={`${65}%`}
          circleRatio={0.75}
          styles={buildStyles({
            rotation: 1 / 2 + 1 / 8,
            strokeLinecap: "butt",
            // trailColor: "#26F32E",
            textColor: "black",
            pathColor: "#1F78B4",
            height:"50px",
            // trailColor: "gold"
          })}
        />
      </div>
        
          <h1 className="text-lg text-center text-gray-500 mt-1 font-bold">
            Picking Accuracy
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.38%</span>
          </p>
          <div className="text-center mb-4  mt-4">
          <div className="">
            <button className="mb-4 px-2 rounded-full w-max text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
              {" "}
              February            </button>
          </div>
        </div>
        </div>
      </div>
   <div ref={inventoryaccuracyRef}>   <WarehouseInventory /></div>
      <Warehousetable/>
    <div ref={inventorysaleRatioRef}>  <Warehousesaleratio/> </div>
    <div ref={inventoryturnoverRef}>  <WarehouseTurnover/></div>
    <div ref={StockRef}> <Warehousestocklist/></div>
    <div ref={PickingaccuracyRef}> <Warehouseaccuracy/></div>
    </div>
  );
}
